import { BaseRes } from 'bff/models/base/baseRes';
import {
  Activities,
  Activity,
  BuildAddrs,
  Codes,
  EmailDomains, Inscat,
  Inscats,
  KycClaim,
  KycClaims,
  MortgageBank,
  Occupations,
  Postcodes,
  SysOption,
  SysOptionReq
} from 'bff/models/info';
import { SysOptions } from 'bff/models/info/sysoptions';
import { FireDoc, Links } from 'bff/models/link';
import { ApplyForm, ApplyFormReq, CheckApplyType, EarthquakeFund, FireAdd, FireCheckApplyTypeReq, FireGetFee, FirePlanList, FireSugAmt, PaymentEBillReq, PaymentEBillRes, PaymentNccReq, PaymentNccRes, PdfExportContent, PolicyNo, PolicyNoReq, RenewalFire, RenewalFireV2 } from 'bff/models/product';
import { PaymentMethod } from 'bff/models/product/paymentMethod';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { CodeId } from 'constants/enums/codeId.enum';
import { LinkCategory } from 'constants/enums/linkCategory.enum';
import { PaymentMethod as PaymentMethodEnum } from 'constants/enums/paymentMethod.enum';
import { ReturnCode } from 'constants/enums/returnCode.enum';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { SysOptType } from 'constants/enums/sysOptType.enum';
import commonService from 'utils/commonService';
import sweetAlertService from 'utils/sweetAlertService';
import apiService from './apiService';
import _ from 'lodash';
import { InsType } from 'constants/enums/insType.enum';
import apiCommonService from 'bff/services/commonService';

/**
 * @description 取得暫存的住火險投保作業資料
*/
const fetchTempFireState = async () => {
  const res = await apiService.fetchInsureProcessFireTempState();
  return { ...res };
};

/**
 * @description 取得  初始化資料
*/
const fetchInitSetting = async () => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();

  const result = await Promise.all([
    apiService.fetchInscat(baseReq, reqConfig),
    apiService.fetchPostcode(baseReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI)
  ]).then(([inscatsRes, postcodesRes, UICodeRes]) => {
    const inscatsBaseRes:BaseRes<Inscats> = { ...inscatsRes };
    const inscatRes = _.find(inscatsBaseRes.TRANRS.INSURANCE_CATEGORY, (inscat:Inscat) => inscat.INS_TYPE_ID === InsType.Fire) as Inscat;
    const postcodesBaseRes: BaseRes<Postcodes> = { ...postcodesRes };
    const UICodeBaseRes: BaseRes<Codes> = { ...UICodeRes };

    const res = {
      inscat: { ...inscatRes },
      postcodes: commonService.arrayTypeReturn(postcodesBaseRes.TRANRS.POSTCODE),
      UICodes: commonService.arrayTypeReturn(UICodeBaseRes.TRANRS.CODES)
    };
    return res;
  });

  return result;
};

/**
 * @description 取得 填寫房屋資料頁 初始化資料
*/
const fetchInitBuildingInfo = async () => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const sysOptionReq: SysOptionReq = {
    PCLASS: [SysOptType.BUILDSTRUCT, SysOptType.DECOCOST, SysOptType.ROOFTYPE, SysOptType.YESNO]
  };

  const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);

  const result = await Promise.all([
    apiService.fetchSysOptions(sysOptionBaseReq, reqConfig),
    apiService.fetchLinkByCategory(baseReq, reqConfig, LinkCategory.FireDoc)
  ]).then(([sysOptRes, docLinksRes]) => {
    const sysOptBaseRes: BaseRes<SysOptions> = { ...sysOptRes };
    const docLinksBaseRes: BaseRes<Links<FireDoc>> = { ...docLinksRes };

    const res = {
      buildStructSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.BUILDSTRUCT])),
      decoCostSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.DECOCOST])),
      roofTypeSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.ROOFTYPE])),
      yesnoSysOpts: sysOptBaseRes.TRANRS[SysOptType.YESNO].sort((first: SysOption, second: SysOption) => {
        if (first.PARAM_ORDER && second.PARAM_ORDER) return second.PARAM_ORDER - first.PARAM_ORDER;
        return 0;
      }),
      docLinks: commonService.arrayTypeReturn(docLinksBaseRes.TRANRS.LINKS?.FIREDOC)
    };

    return res;
  });

  return result;
};

/**
 * @description 查詢建築物地址選項清單
*/
const fetchBuildAddr = async (cityId: string, areaId: string) => {
  const baseReq = commonService.getApiReqData({ CITY_ID: cityId, AREA_ID: areaId });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchBuildAddr(baseReq, reqConfig).then((res: BaseRes<BuildAddrs>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return { ...res.TRANRS };
  }
};

/**
 * @description 查詢地震基金複保險
*/
const queryEarthquakeFund = async (startDate: string, endDate: string, postCode: string, fullAddress: string) => {
  const baseReq = commonService.getApiReqData({ START_DATE: startDate, END_DATE: endDate, POSTCODE: postCode, ADDRESS: fullAddress });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.queryEarthquakeFund(baseReq, reqConfig).then((res: BaseRes<EarthquakeFund>) => res);

  if (res.MWHEADER.RETURNCODE === ReturnCode.CodeSuccess) {
    return res.MWHEADER.RETURNCODE;
  }

  // commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  // } else {
  // if (res.MWHEADER.RETURNCODE === ReturnCode.CodeNoInfo) {
  //   return res.MWHEADER.RETURNDESC;
  // }

  // if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
  //   commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  // } else {
  //   return { ...res.TRANRS };
  // }
};

/**
 * @description 查詢地震基金複保險 V2
*/
const queryEarthquakeFundV2 = async (startDate: string, endDate: string, postCode: string, fullAddress: string, insured: string[], bcType: string) => {
  const baseReq = commonService.getApiReqData({ START_DATE: startDate, END_DATE: endDate, POSTCODE: postCode, ADDRESS: fullAddress, INSURED: insured, BC_TYPE: bcType });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.queryEarthquakeFundV2(baseReq, reqConfig).then((res: BaseRes<EarthquakeFund>) => res);
  return res;
};

/**
 * @description 查詢續保件
*/
const renewalFire = async (req: any) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.renewalFire(baseReq, reqConfig).then((res: BaseRes<RenewalFire>) => res);

  return res.TRANRS;
};

/**
 * @description 查詢續保件
 */
const renewalFireV2 = async (req: any) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.renewalFireV2(baseReq, reqConfig).then((res: BaseRes<RenewalFireV2>) => res);
  // const res = JSON.parse(JSON.stringify({
  //   "MWHEADER": {
  //     "TXNSEQ": "5a389c31-eb89-4cc6-9bc1-04267fa64727",
  //     "RETURNCODE": "0000",
  //     "RETURNDESC": "成功",
  //     "SORT_PAGE": {}
  //   },
  //   "TRANRS": {
  //     "DATA": [
  //       {
  //         "fullAddress": "台中市北屯區瀋陽路3段20號6樓之2",
  //         "policyNo": "0010NRA00284",
  //         "recStatus": "0",
  //         "transactionNo": "00A1000843",
  //         "expirateDate": "20220408",
  //         "upFloor": "18",
  //         "downFloor": "4",
  //         "structureCode": "01",
  //         "roofCode": "14",
  //         "acreage": "35.140",
  //         "buildingYear": "99",
  //         "zipCode": "406",
  //         "address1": "台中市",
  //         "address2": "北屯區",
  //         "address3": "瀋陽路3段20號6樓之2",
  //         "floor": "6",
  //         "addressNum": "",
  //         "firAmt": "3812700.00",
  //         "assuredName": "林姿怡",
  //         "assuredId": "B221723388",
  //         "aBir": "",
  //         "aFm": "",
  //         "assuredZipCode": "406",
  //         "assuredMobile": "0919164168",
  //         "assuredAddress1": "台中市",
  //         "assuredAddress2": "北屯區",
  //         "assuredAddress3": "台中市北屯區瀋陽路三段20號6樓之2",
  //         "mortFlag": "Y",
  //         "remark": "",
  //         "returnCode": "0"
  //       }
  //     ]
  //   }
  // }));

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
    return undefined;
  }

  return res.TRANRS;
};

/**
 * @description 初始化商品選擇頁資料
*/
const fetchInitSelect = async (firePlanListReq: any) => {
  const baseReq = commonService.getApiReqData();

  const firePlanListBaseReq = commonService.getApiReqData(firePlanListReq);
  const reqConfig = commonService.getReqConfig();
  // const sysOptionReq : SysOptionReq = {
  //   PCLASS: [SysOptType.BUILDSTRUCT, SysOptType.DECOCOST, SysOptType.ROOFTYPE, SysOptType.YESNO]
  // };

  // const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);
  // console.log('firePlanListBaseReq', firePlanListBaseReq);
  // sysOptRes
  const result = await Promise.all([
    apiService.fetchFirePlans(firePlanListBaseReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.POL_VAL),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.FIREPROPRM, CodeId.FIREPROPRM01)
  ]).then(([firePlanListRes, polvalCodeRes, firePropCodeRes]) => {
    // const sysOptBaseRes:BaseRes<SysOptions> = { ...sysOptRes };
    const firePlansBaseRes: BaseRes<FirePlanList> = { ...firePlanListRes };
    const polvalCodeBaseRes: BaseRes<Codes> = { ...polvalCodeRes };
    const firePropCodeBaseRes: BaseRes<Codes> = { ...firePropCodeRes };

    const res = {
      firePlans: commonService.arrayTypeReturn(firePlansBaseRes.TRANRS.PRODUCTS),
      polValCodes: commonService.arrayTypeReturn(polvalCodeBaseRes.TRANRS.CODES),
      firePropCodes: commonService.arrayTypeReturn(firePropCodeBaseRes.TRANRS.CODES)
    };

    return res;
  });

  return result;
};

/**
 * @description 查詢取得計算建議保額
*/
const fetchFireSugAmt = async (fireSugAmtReq: any) => {
  const baseReq = commonService.getApiReqData(fireSugAmtReq);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchFireSugAmt(baseReq, reqConfig).then((res: BaseRes<FireSugAmt>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return commonService.arrayTypeReturn(res.TRANRS.ITEMS);
  }
};

/**
 * @description 執行保費計算
*/
const getFee = async (getFeeReq: any) => {
  const baseReq = commonService.getApiReqData(getFeeReq);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fireGetFee(baseReq, reqConfig).then((res: BaseRes<FireGetFee>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 初始化資料填寫頁資料
*/
const fetchInitFill = async (insTypeId: string) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const sysOptionReq: SysOptionReq = {
    PCLASS: [SysOptType.NATIONALITYV, SysOptType.RELATION, SysOptType.RELATIONL, SysOptType.MARRIAGE, SysOptType.YESNO, SysOptType.MORTGAGE_STATUS]
    // PCLASS: [SysOptType.NATIONALITYV, SysOptType.PODELIVERY, SysOptType.RELATION, SysOptType.RELATIONL, SysOptType.MARRIAGE, SysOptType.YESNO, SysOptType.MORTGAGE_STATUS]
  };
  const kycBaseReq = commonService.getApiReqData({ INS_TYPE_ID: insTypeId });

  const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);
  const policyDeliverySysOpts = await apiCommonService.getDeliveryMethods(insTypeId as InsType) ?? [];
  // console.log('firePlanListBaseReq', firePlanListBaseReq);
  // sysOptRes
  const result = await Promise.all([
    apiService.fetchSysOptions(sysOptionBaseReq, reqConfig),
    apiService.fetchEmailDN(baseReq, reqConfig),
    apiService.fetchOccupation(baseReq, reqConfig),
    apiService.fetchKycClaim(kycBaseReq, reqConfig),
    apiService.fetchMortgageBank(baseReq, reqConfig)
  ]).then(([sysOptRes, emailDNsRes, occupationRes, kycClaimsRes, mortgageBanksRes]) => {
    const sysOptBaseRes: BaseRes<SysOptions> = { ...sysOptRes };
    const emailDNsBaseRes: BaseRes<EmailDomains> = { ...emailDNsRes };
    const occupationBaseRes: BaseRes<Occupations> = { ...occupationRes };
    const kycClaimsBaseRes: BaseRes<KycClaims> = { ...kycClaimsRes };
    const mortgageBankBaseRes: BaseRes<MortgageBank> = { ...mortgageBanksRes };

    const res = {
      nationalityVSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.NATIONALITYV])),
      policyDeliverySysOpts: policyDeliverySysOpts,
      relationSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.RELATION])),
      relationLSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.RELATIONL])),
      marriageSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.MARRIAGE])),
      yesnoSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.YESNO])),
      emailDomains: commonService.arrayTypeReturn(emailDNsBaseRes.TRANRS.EMAILDN),
      occupations: commonService.filterOccupationOpts(commonService.arrayTypeReturn(occupationBaseRes.TRANRS.OCCUPATION)),
      kycClaims: [...kycClaimsBaseRes.TRANRS.KYCLIST.sort((first: KycClaim, second: KycClaim) => first.KYC_ORDER - second.KYC_ORDER)],
      mortgageStatusSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.MORTGAGE_STATUS])),
      mortgageBanks: commonService.arrayTypeReturn(mortgageBankBaseRes.TRANRS.BANK)
    };

    return res;
  });

  return result;
};

/**
 * @description 住火險網要網投判斷
*/
const fetchApplyType = async (req: FireCheckApplyTypeReq) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchFireApplyType(baseReq, reqConfig).then((res: BaseRes<CheckApplyType>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS.BC_TYPE;
  }
};

/**
 * @description 取得住火險保單號
*/
const fetchSerialNo = async (req: PolicyNoReq) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchFireSerialNO(baseReq, reqConfig).then((res: BaseRes<PolicyNo>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS.SERIALNO;
  }
};

/**
 * @description 住火險保單共通規則檢核
*/
const policyCommonRuleCheck = async (req: any) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.validFireInsCommonRule(baseReq, reqConfig).then((res: BaseRes<any>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    if (res.TRANRS && res.TRANRS.ERROR_MSG && res.TRANRS.ERROR_MSG.length > 0) {
      return res.TRANRS;
    }
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 住火險保單規則檢核
*/
const policyRuleCheck = async (req: any) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.validFireInsRule(baseReq, reqConfig).then((res: BaseRes<any>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    if (res.TRANRS && res.TRANRS.ERROR_MSG && res.TRANRS.ERROR_MSG.length > 0) {
      return res.TRANRS;
    }
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 新增住火險保單資料
*/
const addFire = async (req: FireAdd) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.addFire(baseReq, reqConfig).then((res: BaseRes<any>) => res);

  switch (res.MWHEADER.RETURNCODE) {
    case ReturnCode.CodeSuccess:
    case ReturnCode.CodePassApplyNo:
      return res.MWHEADER.RETURNDESC;
    default:
      commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE, '新增保單資料失敗');
      break;
  }
  // if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
  //   commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  // } else {
  //   return res.TRANRS;
  // }
};

/**
 * @description 取得 確認付款頁 初始化資料
 * @param serialNo 要保號
*/
const fetchInitPayment = async (serialNo: string, insTypeId: string) => {
  const baseReq = commonService.getApiReqData({ APPLY_NO: serialNo, INS_TYPE_ID: insTypeId });
  const reqConfig = commonService.getReqConfig();

  const sysOptionReq: SysOptionReq = {
    PCLASS: [SysOptType.INSROLETYPE]
  };
  // console.log('fetchInitPayment', baseReq);
  const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);

  const result = await Promise.all([
    apiService.fetchPaymentMethod(baseReq, reqConfig),
    apiService.fetchSysOptions(sysOptionBaseReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.BARCODE_NOTE),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.BARCODE_NOTICE)
  ]).then(([paymentMethodRes, sysOptRes, barcodeNoteCodeRes, barcodeNoticeCodeRes]) => {
    const paymentBaseRes: BaseRes<PaymentMethod> = { ...paymentMethodRes };
    const sysOptBaseRes: BaseRes<SysOptions> = { ...sysOptRes };
    const barcodeNoteCodeBaseRes: BaseRes<Codes> = { ...barcodeNoteCodeRes };
    const barcodeNoticeCodeBaseRes: BaseRes<Codes> = { ...barcodeNoticeCodeRes };

    const res = {
      paymentMethod: { ...paymentBaseRes.TRANRS },
      insRoleTypeSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.INSROLETYPE])),
      barcodeNoteCodes: commonService.arrayTypeReturn(barcodeNoteCodeBaseRes.TRANRS.CODES),
      barcodeNoticeCodes: commonService.arrayTypeReturn(barcodeNoticeCodeBaseRes.TRANRS.CODES)
    };

    return res;
  });

  return result;
};

/**
 * @description 執行線上付款-信用卡
*/
const paymentNccc = async (req: PaymentNccReq) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.paymentNccc(baseReq, reqConfig).then((res: BaseRes<PaymentNccRes>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    const htmlStr = res.TRANRS && res.TRANRS.PAYMENT
      ? `${res.TRANRS.PAYMENT.RESPONSECODE} ${res.TRANRS.PAYMENT.RESPONSEMSG}`
      : `${res.MWHEADER.RETURNDESC}<br />(error code : ${res.MWHEADER.RETURNCODE})`;

    sweetAlertService.modal({
      icon: SweetAlertIcon.Info,
      html: htmlStr
    });
  } else {
    return res.MWHEADER.RETURNCODE;
  }
};

/**
 * @description 執行線上付款-活期帳戶
*/
const paymentEBill = async (req: PaymentEBillReq) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.paymentEBill(baseReq, reqConfig).then((res: BaseRes<PaymentEBillRes>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    sweetAlertService.modal({
      icon: SweetAlertIcon.Info,
      html: `${res.MWHEADER.RETURNDESC}<br />(error code : ${res.MWHEADER.RETURNCODE})`
    });
  } else {
    return res.MWHEADER.RETURNCODE;
  }
};

/**
 * @description 取得投保完成頁，活動 Banner 資料
 * @param insTypeId 險種類別
*/
const fetchActivities = async (insTypeId: string) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();

  const result = await Promise.all([
    apiService.fetchActivitiesByInsTypeId(baseReq, reqConfig, insTypeId)
  ]).then(([activitiesRes]) => {
    const activitiesBaseRes: BaseRes<Activities> = { ...activitiesRes };

    const res = {
      activities: {
        MORE_ACTIVITY_URL: activitiesBaseRes.TRANRS.MORE_ACTIVITY_URL ? activitiesBaseRes.TRANRS.MORE_ACTIVITY_URL : '',
        ACTIVITY: activitiesBaseRes.TRANRS.ACTIVITY ? [...activitiesBaseRes.TRANRS.ACTIVITY.sort((first: Activity, second: Activity) => +first.SHOW_ORDER - +second.SHOW_ORDER)] : new Array(0)
      }
    };

    return res;
  });

  return result;
};

/**
 * @description 初始化 成功投保頁
*/
const fetchInitSuccess = async (paymentMethod: string) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();

  const sysOptionReq: SysOptionReq = {
    PCLASS: [SysOptType.EMAIL_NOTIFY, SysOptType.DOC_ID, SysOptType.PODELIVERY]
  };

  const sysOptionBaseReq = commonService.getApiReqData(sysOptionReq);

  const promiseArray = [apiService.fetchSysOptions(sysOptionBaseReq, reqConfig)];
  if (paymentMethod === PaymentMethodEnum.BarCode) {
    promiseArray.push(apiService.fetchCodes(baseReq, reqConfig, CodeClass.INS_DONE_BAR));
  } else {
    promiseArray.push(apiService.fetchCodes(baseReq, reqConfig, CodeClass.INS_DONE));
  }

  const result = await Promise.all([...promiseArray]).then(([sysOptRes, insDoneRes]) => {
    const sysOptBaseRes: BaseRes<SysOptions> = { ...sysOptRes };
    const insDoneBaseRes: BaseRes<Codes> = { ...insDoneRes };

    const res = {
      emailNotifySysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.EMAIL_NOTIFY])),
      docIdSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.DOC_ID])),
      insDoneCode: paymentMethod === PaymentMethodEnum.BarCode ? [] : commonService.arrayTypeReturn(insDoneBaseRes.TRANRS.CODES),
      insDoneBarCode: paymentMethod === PaymentMethodEnum.BarCode ? commonService.arrayTypeReturn(insDoneBaseRes.TRANRS.CODES) : [],
      policyDeliverySysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptBaseRes.TRANRS[SysOptType.PODELIVERY]))
    };

    return res;
  });

  return result;
};

/**
 * @description 文件套印
*/
const downloadApplyForm = async (applyFormReqContent: PdfExportContent) => {
  const applyFormReq: ApplyFormReq = {
    PDF_EXPORT: [applyFormReqContent]
  };

  const baseReq = commonService.getApiReqData(applyFormReq);
  const reqConfig = commonService.getReqConfig();
  // console.log('req', JSON.stringify(baseReq));
  const res = await apiService.downloadApplyForm(baseReq, reqConfig).then((res: BaseRes<ApplyForm>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE, '取得檔案位置失敗');
  } else {
    return res.TRANRS.FILE_URL;
  }
};

/**
 * @description 取得繳費條碼頁面 URL
 */
const fetchBarcodeUrl = async (applyNo: string, payerName: string) => {
  const baseReq = commonService.getApiReqData({ APPLY_NO: applyNo, PAYER_NAME: payerName });
  const reqConfig = commonService.getReqConfig();
  // console.log('req', JSON.stringify(baseReq));
  const res = await apiService.fetchBarcodeUrl(baseReq, reqConfig).then((res: BaseRes<any>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS.BARCODE_URL;
  }
};

export default {
  fetchTempFireState,
  fetchInitSetting,
  fetchInitBuildingInfo,
  fetchBuildAddr,
  queryEarthquakeFund,
  queryEarthquakeFundV2,
  renewalFire,
  renewalFireV2,
  fetchInitSelect,
  fetchFireSugAmt,
  getFee,
  fetchInitFill,
  fetchApplyType,
  fetchSerialNo,
  policyCommonRuleCheck,
  policyRuleCheck,
  addFire,
  fetchInitPayment,
  paymentNccc,
  paymentEBill,
  fetchActivities,
  fetchInitSuccess,
  downloadApplyForm,
  fetchBarcodeUrl
};
